import type { ReactNode } from 'react';
import { Box, ScrollArea } from '@radix-ui/themes';

interface MainProps {
  children: ReactNode;
}

export function Main({ children }: MainProps) {
  return (
    <ScrollArea
      style={{
        flex: 1,
        minHeight: 0,
      }}
    >
      <Box
        px="4"
        py="4"
        mx="auto"
        style={{
          maxWidth: 768,
          width: '100%',
        }}
      >
        {children}
      </Box>
    </ScrollArea>
  );
}
